var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderSheetModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.828 60.3964L129.85 60.3495L121.191 50.614",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.828 60.3964L129.85 60.3495L121.191 50.614",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.851 60.3504L121.192 50.6149L108.77 50.2629",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.85 60.3499L123.916 73.0767L111.482 73.1622",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.856 60.7265L107.379 50.48L101.442 63.2126L109.922 73.4534L115.856 60.7265Z",
    fill: "#DB6C2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.851 60.3506L117.221 60.4823",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.586 132.618H1L12.0858 78.6971C12.3113 77.4247 12.9697 76.2694 13.9496 75.427C14.9294 74.5846 16.1704 74.1069 17.4622 74.0747H98.1473C98.8307 74.1046 99.499 74.2855 100.104 74.6044C100.709 74.9233 101.236 75.3723 101.647 75.9191C102.058 76.4659 102.343 77.0969 102.481 77.7669C102.62 78.4368 102.608 79.1291 102.446 79.7939L91.586 132.618Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8086 72.4822L103.717 27.6396L149 48.7535L127.886 94.0269L105 83.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 132.618V53.5195H24.6797L28.6557 61.2267H32.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.665 19.9169L92.29 19.9142L92.665 19.9169ZM92.125 44.5C92.125 44.7071 92.2929 44.875 92.5 44.875C92.7071 44.875 92.875 44.7071 92.875 44.5H92.125ZM92.6102 19.7831L92.4419 20.1182L92.6102 19.7831ZM92.655 19.8282L92.9913 19.6622L92.655 19.8282ZM35.7213 19.783L35.5537 19.4476L35.7213 19.783ZM35.6766 19.8278L35.3411 19.6601L35.6766 19.8278ZM35.825 20.1475H92.5059V19.3975H35.825V20.1475ZM36.041 73.6932V19.9315H35.291V73.6932H36.041ZM92.29 19.9142C92.2762 21.8907 92.125 43.544 92.125 44.5H92.875C92.875 43.5475 93.0262 21.8992 93.04 19.9195L92.29 19.9142ZM92.5059 20.1475C92.5206 20.1475 92.5296 20.1475 92.5368 20.1476C92.544 20.1477 92.5442 20.1479 92.5408 20.1476C92.5345 20.1471 92.4925 20.1436 92.4419 20.1182L92.7785 19.448C92.7067 19.412 92.6403 19.4032 92.601 19.4C92.5659 19.3972 92.5275 19.3975 92.5059 19.3975V20.1475ZM93.04 19.9195C93.0401 19.9068 93.0497 19.7807 92.9913 19.6622L92.3187 19.9942C92.3091 19.9747 92.3021 19.955 92.2973 19.936C92.2928 19.918 92.2912 19.904 92.2905 19.8968C92.2899 19.8902 92.29 19.8872 92.2901 19.8915C92.2901 19.896 92.2901 19.902 92.29 19.9142L93.04 19.9195ZM92.4419 20.1182C92.3884 20.0914 92.3452 20.0478 92.3187 19.9942L92.9913 19.6622C92.9455 19.5696 92.8708 19.4944 92.7785 19.448L92.4419 20.1182ZM35.825 19.3975C35.8036 19.3975 35.7653 19.3972 35.7304 19.4C35.6912 19.4031 35.6251 19.4119 35.5537 19.4476L35.8889 20.1185C35.8386 20.1436 35.7968 20.1471 35.7905 20.1476C35.787 20.1478 35.7872 20.1477 35.7944 20.1476C35.8015 20.1475 35.8104 20.1475 35.825 20.1475V19.3975ZM36.041 19.9315C36.041 19.9169 36.041 19.908 36.0411 19.9008C36.0412 19.8936 36.0414 19.8935 36.0411 19.8969C36.0406 19.9033 36.0372 19.945 36.012 19.9954L35.3411 19.6601C35.3054 19.7316 35.2967 19.7977 35.2935 19.8368C35.2907 19.8717 35.291 19.91 35.291 19.9315H36.041ZM35.5537 19.4476C35.4617 19.4935 35.3871 19.5681 35.3411 19.6601L36.012 19.9954C35.9854 20.0487 35.9422 20.0918 35.8889 20.1185L35.5537 19.4476Z",
    fill: "#1F323D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2089 33.0618H48.2866V64.0618H80.2089V33.0618Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3286 51.2236V31.5979",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9907 47.0042H70.8732",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.209 47.0042H51.5439",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3286 65.4019V59.7131",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSheetModel);
export default __webpack_public_path__ + "static/media/folder_sheet_model.97b852a9308b06407b54b9287475e899.svg";
export { ForwardRef as ReactComponent };